// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/communication-tool/communication-tool-collection/communication-tool-collection.scss
// module id = 498
// module chunks = 0